<template>
    <div class="bgView">
        <div class="top-tabs">
            <a href="javascript:;">我的课程</a>
        </div>
        <!--课程列表-->
        <div class="course-list">
            <ul class="clearfix" v-if="hasBuyLessionList.length > 0">
                <li class="course-item" v-for="(lessionModel,index) in hasBuyLessionList" :key="index" @click="courseItemOnSelected(index,0)">
                    <div class="item-content">
                        <!-- http://7xr9ex.com1.z0.glb.clouddn.com/ -->
                        <img :src="lessionModel.picBigUrl">
                        <div class="hover-layer">
                            <span class="join-classroom btn-orange">进入课堂</span>
                        </div>
                    </div>
                     <div class="item-footer">
                        <div class="item-title">{{lessionModel.courseName}}</div>     
                        <div class="item-line item-line-bottom">
                            <div class="item-people-num">
                                <span>{{lessionModel.baseNum}}</span><span>人学习</span>
                            </div>
                        </div>
                        <b class="bottom-line"></b>
                    </div>
                </li>
            </ul>
            <div v-else class="empty" style="min-height:auto;">
                <img src="../../../assets/images/empty.png">
            </div>
            <div class="page-wrap" v-if="hasBuyLessionList.length > 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="6" layout="prev, pager, next,total" :total="total">
                </el-pagination>
            </div>
            <div class="page-wrap" v-else>
                <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="oneByone_currentPage" :page-size="6" layout="prev, pager, next,total" :total="oneByone_total">
                </el-pagination> -->
            </div>
        </div>

        <div class="tuijian">
			<h3 class="my-tit">课程推荐</h3>
			<div class="course-list">
				<ul class="clearfix">
					<li class="course-item" v-for="(courseModel,index) in hotsCourseList" :key="index" @click="courseItemOnSelected(index,1)">
                        <div class="item-content">
                            <!-- ../../../assets/images/list-1.png -->
                            <img :src="courseModel.picBigUrl">
                            <div class="hover-layer">
                                <span class="join-classroom btn-orange">进入课堂</span>
                            </div>
                        </div>
                        <div class="item-footer">
                            <div class="item-title">{{courseModel.courseName}}</div>
                            <div class="item-line item-line-bottom">
                                <div class="fl item-price" v-if="courseModel.realPrice == null || courseModel.realPrice == 0">免费</div>
                            <div class="fl item-price free" v-else>￥{{courseModel.realPrice}}</div>
                                <div class="fr item-people-num">
                                    <span>{{courseModel.baseNum}}</span><span>人学习</span>
                                </div>
                            </div>
                            <b class="bottom-line"></b>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'myCourse',
    data () {
        return {
            currentPage: 1,
            total: 0,
            hasBuyLessionList:[],   //已经购买课程列表
            hotsCourseList:[],      //热门课程
        }
    },
    created(){
        this.loadMyCourseList();    //加载我的课程
        this.getHotsCourse();
    },
    methods:{
        handleSizeChange: function (pageSize){
            console.log(pageSize);
        },
        //加载我的课程列表
        loadMyCourseList(){
            this.$http.post(this.baseUrl()+'/mobile/tbCourse/getMyCourse',       // 还可以直接把参数拼接在url后边
				this.$qs.stringify({
                    page:this.currentPage,
                    pageSize:6,
                    userId: localStorage.userId,
                    token: localStorage.token
				}),{
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(function(res){
                    this.hasBuyLessionList = res.data.data;
                    console.log("加载课程："+this.hasBuyLessionList.length);
                    this.total = res.data.totalNum
                    console.log(res.data.data);
                }).catch(function (error) {
				console.log(error);
			});
        },
        //加载热门课程
        getHotsCourse(){
            this.$http.post(this.baseUrl()+'/mobile/tbCourse/getHotsCourse',       // 还可以直接把参数拼接在url后边
				this.$qs.stringify({
                    page:1,
                    pageSize:4,
                    recommendFlag:'1'
				}),{
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(function(res){
                    this.hotsCourseList = res.data.data;
                    console.log("加载热门课程："+this.hotsCourseList.length);
                    
                }).catch(function (error) {
				console.log(error);
			});
        },
        handleCurrentChange: function (currentPage){
             console.log("加载当前页"+currentPage)
            this.loadMyCourseList();
        },
        courseItemOnSelected: function (index,type) {
            if(type == 0){
                let lessionModel = this.hasBuyLessionList[index]
                // console.log(lessionModel.id)
                // this.$router.push('/courseInfo/'+ lessionModel.id)
                this.$router.push({name:'courseInfo',params:{courseId:lessionModel.id}})
            }else {
                let lessionModel = this.hotsCourseList[index]
                this.$router.push({name:'courseInfo',params:{courseId:lessionModel.id}})
                // console.log(lessionModel.id)
                // this.$router.push('/courseInfo/'+ lessionModel.id)
            }      
            },

    }
}
</script>

<style scoped>
    .bgView{
        background: #fff;
    }
    .top-tabs{
        padding:10px 10px;
        border-bottom: 1px solid #dfdfdf;
        margin-bottom: 10px;
    }
    .top-tabs a{
        margin-right: 15px;
        padding: 10px 10px;
    }
    .top-tabs a:hover{
        color: #f49d40;
    }
    .top-tabs a.active{
        border-bottom: 2px solid #f49d40;
        color: #f49d40;
    }

/*一对一约课*/
    .pad10{
        padding: 10px 10px;
    }
    .oneByOne-item{
        /*padding: 10px 10px;*/
        border-bottom: 1px solid #dfdfdf;
    }
    .oneByOne-item-rightContent{
        width: 680px;
    }
    .oneByOne-item-leftImg{
        margin-bottom: 15px;
        margin-right: 15px;
        width: 176px;
        height: 106px;
        border:1px solid #dfdfdf;
    }
    .oneByOne-item-leftImg img{
        width: 176px;
        height: 106px;
    }
    .oneByOne-item-rightContent-title{
        color: #333;
        font-size: 16px;
        margin-bottom: 20px;
    }
    .oneByOne-item-rightContent-subTit{
        color: #333;
        font-size: 14px;
    }
    .oneByOne-item-rightContent-action{
        margin-top: 25px;
    }
    .oneByOne-item-rightContent-action a{
        padding: 5px 15px;
        background: #f49d40;
        color: #fff;
        margin-left: 10px;
        border-radius: 4px;
    }
/*end*/
    .my-tit{
		padding:10px 10px;
		border-bottom: 1px solid #dfdfdf;
		margin-bottom: 10px;
	}
	.page{
		margin-top: 30px;
		margin-bottom: 10px;
		text-align: center;
	}
    
    .tuijian .course-item .item-content{
        width: 195px;
        height: 124px;
    }
    .tuijian .course-item .item-content img{
        width: 100%;
        max-width: 100%;
    }

    
.course-list .course-item{
  float: left;
  padding: 10px 10px 0 10px;
}
.course-list .course-item:hover{
  background: #fff;
  box-shadow: 1px 1px 4px 2px #ECECEC;
}
.course-item:hover .item-footer .bottom-line{
  border-color: #fff;
}
/*.course-item .item-content{
  position: relative;
  width: 255px;
  height: 152px;
}*/
.course-item .item-content{
  position: relative;
  width: 280px;
  height: 165px;
  overflow: hidden;
}
.course-item .item-content img{
  width: 100%;
  max-width: 100%;
  /*width: 280px;*/
  /*height: 165px;*/
}
.course-item .item-content:hover .hover-layer{
  display: block;
}
.course-item .item-content .hover-layer{
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
}
.course-item .item-content .join-classroom{
  margin-top: 25%;
}
.item-footer .bottom-line{
  width: 87%;
  margin: 0 19px;
  display: inline-block;
  border-bottom: 1px solid #dfdfdf;
}
</style>